// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "msisdn",
                Decco.stringToJson(v.msisdn)
              ],
              [
                "order_id",
                Decco.stringToJson(v.order_id)
              ],
              [
                "penalty_enum_id",
                Decco.intToJson(v.penalty_enum_id)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
